import { useStore } from 'vuex';
import store from '@/store';
export default {
    install: app => {
        // 测试所有生命周期
        app.directive('permission', {
            // 在绑定元素的 attribute 前
            // 或事件监听器应用前调用
            created(el, binding, vnode, prevVnode) {
                // 下面会介绍各个参数的细节
            },
            // 在元素被插入到 DOM 前调用
            beforeMount(el, binding, vnode, prevVnode) {},
            // 在绑定元素的父组件
            // 及他自己的所有子节点都挂载完成后调用
            mounted(el, binding, vnode, prevVnode) {
                let permissions = store.getters && store.getters.permissions;
                const { value } = binding;
                const all_permission = '*:*:*';

                if (value && value instanceof Array && value.length > 0) {
                    const permissionFlag = value;

                    const hasPermissions = permissions.some(permission => {
                        return all_permission === permission || permissionFlag.includes(permission);
                    });

                    if (!hasPermissions) {
                        el.parentNode && el.parentNode.removeChild(el);
                    }
                } else {
                    throw new Error(`请设置操作权限标签值`);
                }
            },
            // 绑定元素的父组件更新前调用
            beforeUpdate(el, binding, vnode, prevVnode) {},
            // 在绑定元素的父组件
            // 及他自己的所有子节点都更新后调用
            updated(el, binding, vnode, prevVnode) {},
            // 绑定元素的父组件卸载前调用
            beforeUnmount(el, binding, vnode, prevVnode) {},
            // 绑定元素的父组件卸载后调用
            //
            unmounted(el, binding, vnode, prevVnode) {}
        });

        app.directive('role', {
            mounted(el, binding) {
                const { value } = binding;
                const super_admin = 'admin';
                const roles = store.getters && store.getters.roles;

                if (value && value instanceof Array && value.length > 0) {
                    const roleFlag = value;

                    const hasRole = roles.some(role => {
                        return super_admin === role || roleFlag.includes(role);
                    });

                    if (!hasRole) {
                        el.parentNode && el.parentNode.removeChild(el);
                    }
                } else {
                    throw new Error(`请设置角色权限标签值"`);
                }
            }
        });

        app.directive('translate', {
            mounted(el, binding) {
                const { value } = binding;
                
                const flag = ['14', '22'];

                if (value && value instanceof Array && value.length > 0) {
                    const vFlag = value;

                    const hasRole = flag.some(role => {
                        return vFlag.includes(role);
                    });
                    if (!hasRole) {
                        el.parentNode && el.parentNode.removeChild(el);
                    }
                } else {
                    throw new Error(`请设置角色权限标签值"`);
                }
            }
        });
    }
};
